<template>
    <div class="equipment">
        <div class="title">
            <img src="../../../assets/square-point.png" alt="">
            <span @click="toAudioAnalysis">{{ elevatorName }}</span>
        </div>
        <div class="con">
            <escalatorChart v-if="elevatorType == 'escalator'" title="电机负载(ap)3" :chartData="escalatorChartData" class="con2" ref="escalatorChartTop">
            </escalatorChart>
            <div class="con2"  v-else>
                <div class="con2-t">
                    <span>电机负载(ap)</span>
           

                    <!-- <span>更多</span> -->
                </div>
                <vibrationCart ref="vibrationCart" title="电机负载(ap)"></vibrationCart>

            </div>
          

            <!-- <div class="con3" v-if="elevatorType == 'elevator'">
                <div class="con3-t">
                    <span>·倾角 (度)</span>
                </div>
                <angleChart ref="angleChart"></angleChart>
            </div> -->
            <escalatorChart v-if="elevatorType == 'escalator'"   title="电机负载(ap)4" :chartData="escalatorChartData2" class="con3"
                ref="escalatorChartBottom">
            </escalatorChart>
            <div v-else ></div>
           
        </div>
    </div>
</template>
    
<script>
import vibrationCart from '../../../components/vibration-chart.vue';
import angleChart from '../../../components/angle-chart.vue';
import distanceChart from "../../../components/distance-chart";
import escalatorChart from './escalator-chart.vue';
import * as echarts from "echarts";
import { log } from 'three';

export default {
    components: {
        escalatorChart,
        vibrationCart,
        angleChart,
        distanceChart,
    },
    data() {
        return {
            curMovementSensor: '',
            elevatorIdInfo: null,
            elevatorId: '',
            elevatorType: '',
            elevatorName: '',
            escalatorChartData: null,
            escalatorChartData2: null,
        };
    },
    mounted() {
    },
    methods: {
        toAudioAnalysis() {
            this.$store.state.curElevatorInfo = this.elevatorIdInfo
            this.$router.push('/home/audioAnalysis')
        },
        requestHistoryData(flag) {
            let escalatorRange = flag == 1 ? this.$store.state.escalatorTimeRange : this.$store.state.escalatorTimeRange2
            const rangeAmount = parseInt(escalatorRange.substr(0, 1));
            const rangeUnit = escalatorRange.substr(1, 1);
            let escalatorInterval = '1m';
            if (escalatorRange === '1h') {
                escalatorInterval = '1s';
            } else if (escalatorRange === '1d') {
                escalatorInterval = '1m';
            } else if (escalatorRange === '1w') {
                escalatorInterval = '5m';
            }
            let params = {
                interval: escalatorInterval,
                sensorList: this.$store.state.curEscalatorSensorList2.join(','),
                dataType: 1,
                elevatorId: this.elevatorId,
                startTime: this.$moment().subtract(rangeAmount, rangeUnit).format('yyyy-MM-DD HH:mm:ss'),
                endTime: this.$moment().format('yyyy-MM-DD HH:mm:ss')
            }
            this.$api.sensor.sensorHistory(params).then((res) => {
                if (res.code === "200") {
                    if (flag == 1) {
                        if (this.$refs.escalatorChartTop.curPosition == '') {
                            this.$refs.escalatorChartTop.curPosition = '上半区'
                        }
                        this.escalatorChartData = this.SensorHistoryToEchartData(1, res.data)
                        this.$nextTick(() => {
                            this.$refs.escalatorChartTop.selectPosition()
                        })
                    } else {
                        if (this.$refs.escalatorChartBottom.curPosition == '') {
                            this.$refs.escalatorChartBottom.curPosition = '下半区'
                        }
                        this.escalatorChartData2 = this.SensorHistoryToEchartData(1, res.data)
                        this.$nextTick(() => {
                            this.$refs.escalatorChartBottom.selectPosition()
                        })
                    }

                }
            });
        },
        requestMotorHistoryData() {
            //电机负载
            let motorRange = this.$store.state.motorTimeRange;
            const rangeAmount = parseInt(motorRange.substr(0, 1));
            const rangeUnit = motorRange.substr(1, 1);
            let motorInterval = '1m';
            if (motorRange === '1h') {
                motorInterval = '1s';
            } else if (motorRange === '1d') {
                motorInterval = '1m';
            } else if (motorRange === '1w') {
                motorInterval = '5m';
            }
            let params = {
                interval: motorInterval,
                sensorList: this.$store.state.curVibrationSensorList.join(','),
                dataType: 1,
                elevatorId: this.elevatorId,
                startTime: this.$moment().subtract(rangeAmount, rangeUnit).format('yyyy-MM-DD HH:mm:ss'),
                endTime: this.$moment().format('yyyy-MM-DD HH:mm:ss')
            }
            this.$api.sensor.sensorHistory(params).then((res) => {
                if (res.code === "200") {
                    const data = this.SensorHistoryToEchartData(1, res.data);
                    this.$refs.vibrationCart.setData(data);
                }
            });
        },
        requestAngleHistoryData() {
            let angleRange = this.$store.state.angleTimeRange;
            const angleAmount = parseInt(angleRange.substr(0, 1));
            const angleUnit = angleRange.substr(1, 1);
            let angleInterval = '1m';
            if (angleRange === '1h') {
                angleInterval = '1s';
            } else if (angleRange === '1d') {
                angleInterval = '1m';
            } else if (angleRange === '1w') {
                angleInterval = '1h';
            }
            this.$api.sensor.sensorHistory({
                interval: angleInterval,
                sensorList: this.curMovementSensor,
                dataType: 4,
                elevatorId: this.elevatorId,
                startTime: this.$moment().subtract(angleAmount, angleUnit).format('yyyy-MM-DD HH:mm:ss'),
                endTime: this.$moment().format('yyyy-MM-DD HH:mm:ss'),
            }).then((res) => {
                if (res.code === "200") {
                    const data = this.SensorHistoryToEchartData(4, res.data);
                    this.$refs.angleChart.setData(data);
                }
            })
        },
        //将历史数据转换为图表需要的数据格式
        SensorHistoryToEchartData(dataType, data) {
            //倾角
            if (dataType == 4) {
                const chartDataX = data.time;
                const chartDataY = [
                    {
                        type: "line",
                        name: "x",
                        data: data.x,
                        showSymbol: false,
                        color: "#e6a23c",
                        // areaStyle: {
                        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //         {
                        //             offset: 0,
                        //             color: "#e6a23c80",
                        //         },
                        //         {
                        //             offset: 1,
                        //             color: "#e6a23c",
                        //         },
                        //     ]),
                        // },
                    },
                    {
                        type: "line",
                        name: "y",
                        data: data.y,
                        showSymbol: false,
                        itemStyle: {
                            color: "#00d1ed",
                        },
                        // areaStyle: {
                        //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //         {
                        //             offset: 0,
                        //             color: "#00d1ed",
                        //         },
                        //         {
                        //             offset: 1,
                        //             color: "#00d1eda3",
                        //         },
                        //     ]),
                        // },
                    },
                ];

                let legendData = [];
                if (chartDataX && chartDataX.length != 0) {
                    legendData = ["x", "y"];
                }

                return { chartDataX, chartDataY, legendData };
            }

            //振动传感器
            if (dataType === 1) {
                const chartDataX = data.time;
                const chartDataY = !data.data
                    ? null
                    : data.data.map((item, index) => {
                        return {
                            type: "line",
                            name: item.position,
                            data: item.energy,
                            showSymbol: false,
                        };
                    });
                let legendData = [];
                if (data.time && data.time.length != 0) {
                    data.data.forEach((item) => {
                        legendData.push(item.position);
                    });
                }
                return { chartDataX, chartDataY, legendData };
            }
        },
        //获取各传感器历史数据展示图表
        //参数interval 间隔,usbPort,sensorType,windId,edgefId,endTime,startTime
        //获取传感器历史数据定时任务
        getSensorHistoryTimerTask() {
            if (this.curMovementSensor.length === 0 && this.$store.state.curVibrationSensorList.length === 0 && this.$store.state.curEscalatorSensorList.length === 0) {
                return;
            }
            if (this.elevatorType === 'escalator') {//扶梯
                this.requestHistoryData(1)
                this.requestHistoryData(2)
            } else {//直梯
                this.requestMotorHistoryData();
                // this.requestSpeedHistoryData();
                // this.requestAngleHistoryData();
            }
        },
    },
    computed: {},
    watch: {
        "$store.state.angleTimeRange": function () {
            // this.requestAngleHistoryData();
        },
        "$store.state.motorTimeRange": function () {
            this.requestMotorHistoryData();
        },
        "$store.state.escalatorTimeRange": function () {
            this.requestHistoryData(1);
        },
        "$store.state.escalatorTimeRange2": function () {
            this.requestHistoryData(2);
        },
    }
};
</script>
    
<style lang="less" scoped>
.equipment {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .title {
        margin: 8px 0 0 12px;
        display: flex;
        align-items: center;

        span {
            font-size: 16px;
            font-weight: 400;
            color: var(--titleName-color);
            margin-bottom: 2px;
            margin-left: 8px;
            cursor: pointer;
        }
    }

    .con {
        padding: 0 25px 0 32px;
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .con2,
    .con3 {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-top: 20px;
        align-items: center;
    }

    .con2-t,
    .con3-t {
        width: 100%;
        display: flex;
        justify-content: space-between;

        span {
            font-size: 12px;
        }

        span:first-child {
            color: #B4B4B4;
        }

        span:nth-child(2) {
            color: #7F8488;
        }
    }
}

.equipment::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    border-top: 1px solid;
    border-image: linear-gradient(270deg, var(--borderImage), rgba(68, 215, 182, 1)) 1 1;
    border-image-slice: 1;
}
</style>
    
      


// WEBPACK FOOTER //
// src/pages/home/realTime/equipment.vue